import { render, staticRenderFns } from "./paychannelv2.vue?vue&type=template&id=0c61b562&"
import script from "./paychannelv2.vue?vue&type=script&lang=js&"
export * from "./paychannelv2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports